import { render, staticRenderFns } from "./clinch.vue?vue&type=template&id=9e534b9a&scoped=true"
import script from "./clinch.vue?vue&type=script&lang=js"
export * from "./clinch.vue?vue&type=script&lang=js"
import style0 from "./style/potential.scss?vue&type=style&index=0&id=9e534b9a&prod&lang=scss&scoped=true&external"
import style1 from "./clinch.vue?vue&type=style&index=1&id=9e534b9a&prod&lang=scss&scoped=true"
import style2 from "./clinch.vue?vue&type=style&index=2&id=9e534b9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e534b9a",
  null
  
)

export default component.exports